import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function svgPlan(props: RootSvgProps) {
  const { ...others } = props;

  return (
    <RootSvg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <rect width="70" height="70" rx="10" fill="#F8F2FF" />
      <g clipPath="url(#clip0_3344_35646)">
        <path
          d="M40.3334 27L43.3867 30.0533L36.88 36.56L31.5467 31.2267L21.6667 41.12L23.5467 43L31.5467 35L36.88 40.3333L45.28 31.9467L48.3334 35V27H40.3334Z"
          fill="#9C4DF4"
        />
      </g>
      <defs>
        <clipPath id="clip0_3344_35646">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(19 19)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
